// Demo mode lets the whole flow be clicked through while the wallet API is down.
// Opt in per visit with ?demo=1 — never a build default, and the page shows a banner
// whenever it is on, so a canned success can't be mistaken for a real one.

export const demoModeEnabled = (): boolean =>
    typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('demo');

const POLLS_BEFORE_SUCCESS = 2;

const polls = new Map<string, number>();

const countPoll = (sessionId: string): number => {
    const next = (polls.get(sessionId) ?? 0) + 1;
    polls.set(sessionId, next);
    return next;
};

export const demoStartFlow = (sessionId: string) => {
    polls.delete(sessionId);
    return {
        sessionId,
        request_uri: `openid-credential-offer://demo.credenco.com?session=${sessionId}`,
        qr: '',
    };
};

export const demoIssueStatus = (sessionId: string) => ({
    sessionId,
    status: countPoll(sessionId) >= POLLS_BEFORE_SUCCESS ? 'success' : 'pending',
    reason: 'ok',
});

export const demoVerifyStatus = (sessionId: string) => {
    const done = countPoll(sessionId) >= POLLS_BEFORE_SUCCESS;
    return {
        sessionId,
        status: done ? 'success' : 'pending',
        reason: 'ok',
        attributes: done
            ? {
                given_name: 'Klaas',
                family_name: 'Jansma',
                birth_date: '1991-04-17',
                nationality: 'NL',
            }
            : undefined,
    };
};
